module.exports = __webpack_public_path__ + "img/402.0a20a7fb.png";